import React                      from 'react';
import { platedSlots as tooltip } from 'pu-data/Tooltips';
import CheckboxComponent          from './CheckboxComponent';

const PlatedSlots = (props) => {
  const name = 'plated_slots';
  return (
    <CheckboxComponent
      name={name}
      inputId={name}
      label="Plated Slots"
      tooltip={props.tooltip}
      checked={props.parameters[name] === '1'}
      onChange={e => props.onChangeParameter(name, e.target.checked ? '1' : '0')} />
  );
};

PlatedSlots.defaultProps = {
  tooltip,
};

export default PlatedSlots;
